import HeadboardSimple, {
  headboardSimpleHomeAdapter,
} from "../molecules/headboard-simple";
import MyAppointments, {
  myAppointmentsAdapter,
} from "../organisms/my-appointments";
import PricingTable, { pricingTableAdapter } from "../organisms/pricing-table";

import Advantage from "../atoms/advantage-enterprises/advantage-enterprises";
import Appointment from "../organisms/appointment/appointment";
import ArticleContentDescription from "../molecules/article-content-description/articleContentDescription";
import CarouselRates from "../molecules/carousel-rates/carousel-rates";
import ContentDescription from "../atoms/content-description/content-description";
import ContentRotator from "../organisms/content-rotator/contentRotator";
import Cover from "../atoms/cover/cover";
import CoverPayed from "../atoms/cover-payed/cover-payed";
import DropdownCategories from "../molecules/dropdown-categories/dropdownCategories";
import FeaturedJoin from "../molecules/destacado-afiliarse/destacado-afiliarse";
import FeaturedPlans from "../molecules/destacado-planes/destacado-planes";
import FindOutMore from "../molecules/find-out-more/find-out-more";
import FrequentQuestions from "../molecules/frequent-questions/frequentQuestions";
import GridGroup from "../molecules/grid-group/grid-group";
import HowItWorksSection from "../molecules/how-it-work/how-it-works";
import IframesCarousel from "../organisms/iframes-carousel/iframesCarousel";
import Introduction from "../molecules/introduction/introduction";
import LibraryItems from "../molecules/library-items/libraryItems";
import LibraryPodcast from "../molecules/library-podcast/libraryPodcast";
import LinkArticlesCards from "../molecules/link-articles-cards/linkArticlesCards";
import MainArticle from "../molecules/main-article/main-article";
import ModeratorSection from "../molecules/moderator-section/moderatorSection";
import NetworkContentSection from "../molecules/network-content/network-content";
import PersonServicesSection from "../molecules/person-services/person-services";
import Premises from "../molecules/premises/premises";
import PremisesEnterprises from "../molecules/enterprises-premise/enterprises-premises";
import ProductDescriptionLeft from "../molecules/product-description-left/productDescriptionLeft";
import ProductDescriptionRight from "../molecules/product-description-right/productDescriptionRight";
import React from "react";
import Readtime from "../atoms/readtime/readTime";
import Recommended from "../molecules/recommended/recommended";
import RecommendedBooks from "../molecules/recommended-books/recommendedBooks";
import RelatedArticles from "../molecules/related-articles/RelatedArticles";
import RichtextDescription from "../atoms/richtext-description/richtextDescription";
import RouteLeaders from "../molecules/route-leaders/route-leaders";
import ServicesPayed from "../organisms/services-payed/services-payed";
import Shedule from "../organisms/shedule/shedule";
import SupportGroupRates from "../molecules/s-group-rates/supportGroupsRates";
import SupportGroupTabs from "../molecules/support-group-tabs/supportGroupTabs";
import TabsSection from "../molecules/tabs-section/tabsSection";
import TabsSectionInternal from "../molecules/tabs-section-internal/tabsSectionInternal";
import Testimonials from "../molecules/testimonials/testimonials";
import appointmentAdapter from "../organisms/appointment/appointment.adapter";
import contentRotatorAdapter from "../organisms/content-rotator/contentRotator.adapter";

interface LibraryInterface {
  content: any;
  categoryName: string;
  location?: any;
  gigyaContext?: any;
}
const LibraryComponents = (props: LibraryInterface) => {
  const refContent = props.content;
  const categoryName = props.categoryName;

  switch (props.content.tipoComponente) {
    case "GaleriaPrincipal":
      return <Cover {...refContent} nombreCategoria={categoryName} />;
    case "VideoService":
      return <Introduction {...refContent} nombreCategoria={categoryName} />;
    case "AnuncioPrincipal": {
      return (
        <HowItWorksSection {...refContent} nombreCategoria={categoryName} />
      );
    }
    case "Contacto":
      return <FeaturedJoin {...refContent} nombreCategoria={categoryName} />;
    case "Tarifas":
      return <CarouselRates {...refContent} nombreCategoria={categoryName} />;
    case "Cartas":
      return <Testimonials {...refContent} nombreCategoria={categoryName} />;
    case "Beneficios":
      return (
        <PersonServicesSection {...refContent} nombreCategoria={categoryName} />
      );
    case "DestacadosHome":
      return <CoverPayed {...refContent} nombreCategoria={categoryName} />;
    case "SeccionTabs":
      return (
        <TabsSection
          {...refContent}
          nombreCategoria={categoryName}
          location={props.location}
        />
      );
    case "RotadorPrincipal":
      return <FindOutMore {...refContent} nombreCategoria={categoryName} />;
    case "Estanteria":
      return <MainArticle {...refContent} nombreCategoria={categoryName} />;
    case "GaleriaExtendida":
      return (
        <TabsSectionInternal
          {...refContent}
          nombreCategoria={categoryName}
          location={props.location}
        />
      );
    case "Testimonios":
      return (
        <NetworkContentSection {...refContent} nombreCategoria={categoryName} />
      );
    case "Wellness":
      return <FeaturedPlans {...refContent} nombreCategoria={categoryName} />;
    case "Recomendador":
      return <ServicesPayed {...refContent} nombreCategoria={categoryName} />;
    case "ModalDirectorio":
      return <ServicesPayed {...refContent} nombreCategoria={categoryName} />;
    case "DestacadoParaTi":
      return <Recommended {...refContent} nombreCategoria={categoryName} />;
    case "Spotify":
      return <LibraryPodcast {...refContent} nombreCategoria={categoryName} />;
    case "CategoriasBibilioteca":
      return (
        <DropdownCategories {...refContent} nombreCategoria={categoryName} />
      );
    case "SectionContainer":
      return (
        <LinkArticlesCards {...refContent} nombreCategoria={categoryName} />
      );
    case "Destacados":
      return <ContentRotator {...contentRotatorAdapter(refContent)} />;
    case "ContenidoEnriquecido":
      return (
        <ContentDescription {...refContent} nombreCategoria={categoryName} />
      );
    case "Historia":
      return <RelatedArticles {...refContent} nombreCategoria={categoryName} />;
    case "InformacionInstitucional":
      return <Premises {...refContent} nombreCategoria={categoryName} />;
    case "RotadorData":
      return (
        <RecommendedBooks {...refContent} nombreCategoria={categoryName} />
      );
    case "CuadriculaClubes":
      return <GridGroup {...refContent} nombreCategoria={categoryName} />;
    case "DestacadoInterna":
      return <Advantage {...refContent} nombreCategoria={categoryName} />;
    case "Galeria":
      return (
        <PremisesEnterprises {...refContent} nombreCategoria={categoryName} />
      );
    case "Ejes":
      return <RouteLeaders {...refContent} nombreCategoria={categoryName} />;
    case "Agenda":
      return <Shedule {...refContent} nombreCategoria={categoryName} />;
    case "TabsClubes":
      return (
        <SupportGroupTabs {...refContent} nombreCategoria={categoryName} />
      );
    case "TarifasGrupoApoyo":
      return (
        <SupportGroupRates {...refContent} nombreCategoria={categoryName} />
      );
    case "MiembrosClub":
      return (
        <ModeratorSection {...refContent} nombreCategoria={categoryName} />
      );
    case "ContenidoEnriquecido":
      return (
        <RichtextDescription {...refContent} nombreCategoria={categoryName} />
      );
    case "ContenidoEnriquecidoArticulo":
      return (
        <ArticleContentDescription
          {...refContent}
          nombreCategoria={categoryName}
        />
      );
    case "TiempoLectura":
      return <Readtime {...refContent} nombreCategoria={categoryName} />;

    case "PreguntasFrecuentesV2":
      return (
        <FrequentQuestions {...refContent} nombreCategoria={categoryName} />
      );
    case "DescripcionProductoIzquierda":
      return (
        <ProductDescriptionRight
          {...refContent}
          nombreCategoria={categoryName}
        />
      );
    case "DescripcionProducto":
      return (
        <ProductDescriptionLeft
          {...refContent}
          nombreCategoria={categoryName}
        />
      );
    case "AgendamientoDeCitas":
      return <Appointment {...appointmentAdapter(refContent)} />;
    case "TablaTarifas":
      return <PricingTable {...pricingTableAdapter(refContent)} />;
    case "CabeceraHome":
      return <HeadboardSimple {...headboardSimpleHomeAdapter(refContent)} />;
    case "Articulos":
      return <LibraryItems {...refContent} nombreCategoria={categoryName} />;
    case "IframesCarousel":
      return <IframesCarousel {...refContent} nombreCategoria={categoryName} />;
    case "MyAppointments":
      return <MyAppointments {...myAppointmentsAdapter(refContent)} />;
  }
  return <></>;
};

export default LibraryComponents;
